export default __webpack_public_path__ + "static/media/list.043ffb59.svg";